import React from "react";
import ReactInputMask from "react-input-mask";
import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { FONTS } from "../../Constant/Theme";
import SmartImage from "../SmartImage";
import CustomText from "../Text";

const Container = styled.div`
  margin-top: 3px;
  margin-bottom: 10px;
  text-align: left;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1.5px solid #6663;
  padding: 5px;
  border-radius: 10px;
  margin-top: 5px;
`;

const InputMaskStyled = styled(ReactInputMask)`
  width: 80%;
  color: #000;
  border: none;
  outline: none;
  border-radius: 10px;
  padding: 10px;
  ${FONTS.Regular14};
`;

const ErrorText = styled(CustomText)`
  font-size: 15px;
  color: "red";
  padding: 5px;
`;

const Icon = styled(SmartImage)`
  margin-left: 15px;
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const MasKInput = ({
  type,
  icon,
  mask,
  text,
  style,
  mainStyle,
  onBlur,
  name,
  error,
  value,
  editable,
  maxLength,
  iconName,
  rightIcon,
  onChangeText,
  rightIconPress,
  rightIconColor = Colors.dangerColor,
  placeholder = "",
  readOnly,
  headingStyles,
  maskChar,
  ...inputProps
}) => {
  return (
    <Container style={mainStyle}>
      {text && (
        <CustomText
          style={{ fontWeight: "600", ...FONTS.Bold16, color: Colors.primary }}
          text={text}
        />
      )}
      <InputContainer style={style}>
        {icon && <Icon src={icon} style={{ height: 22, width: 22 }} />}
        <InputMaskStyled
          type={type}
          onBlur={onBlur}
          name={name}
          maskChar=""
          iconName={iconName}
          placeholder={placeholder}
          editable={editable}
          value={value}
          maxLength={mask ? null : maxLength}
          defaultValue={value}
          mask={mask}
          onChange={(text) => onChangeText(name, text.target.value)}
          readOnly={readOnly}
          alwaysShowMask={false}
          {...inputProps}
        />
        {rightIcon && (
          <div onClick={rightIconPress} style={{ cursor: "pointer" }}>
            <Icon
              src={rightIcon}
              style={{ height: 22, width: 22, marginRight: 5 }}
            />
          </div>
        )}
      </InputContainer>
      {error && <ErrorText text={error} style={{ color: "red" }} />}
    </Container>
  );
};

export default MasKInput;
